import { useQuery } from '@tanstack/react-query';
import { rcmKeys } from '@/api/queryKeys';
import { sessionApi } from '../api/sessionApi';

/**
 * The RCM backend's view of the session.
 *
 * Deliberately not merged into `useAuthStore`: that store holds what the
 * account app's token says, and this holds what RCM resolved from it. Keeping
 * them apart is what makes a mismatch visible — a token for a location RCM
 * has never been set up for comes back with `practice: null` rather than
 * looking like a signed-out user.
 */
export function useRcmSession() {
  const query = useQuery({
    queryKey: rcmKeys.session.me,
    queryFn: () => sessionApi.me(),
    // Who you are and where you are does not change while a tab is open; a
    // re-login remounts the app.
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  return {
    session: query.data,
    practice: query.data?.practice ?? null,
    locationId: query.data?.location_id ?? null,
    permissions: query.data?.permissions ?? [],
    isLoading: query.isPending,
    error: query.error,
    refetch: query.refetch,
  };
}
